import React from 'react'
import ProgramTag from './ProgramTag'
import PropTypes from 'prop-types'

// reference tag list
// const resultTags = [
//   { 
//     programType: 'address', 
//     text: result.addresses_list[0], 
//     onClick: () => props.setSelectedAddress(formatProgramAddressForMap(mockAddress)),
//   },
//   { programType: 'finaid', text: 'Financial Aid', },
//   { programType: 'transit', text: 'Accessible by Public Transportation', },
// ]

const ProgramTagList = ({ tags = [], }) => <>{
  tags.map((tag, idx) => 
    <ProgramTag
      type={tag.type}
      text={tag.text}
      content={tag.content}
      onClick={tag.onClick}
      key={`prg-tag-${idx}`}
      prependDivider={(idx > 0)}
    />
  )
}</>

ProgramTagList.propTypes = {
  tags: PropTypes.array,
}

export default ProgramTagList
